const updateTiersSlider = () => {
  const loyaltyTiersSlider = document.querySelector('[data-oke-loyalty-vip-tiers] .swiper');
  const swiperInstance = loyaltyTiersSlider?.swiper;

  if (!loyaltyTiersSlider || !swiperInstance) {
    return;
  }

  swiperInstance.params.autoHeight = true;

  swiperInstance.update();
}

const debouncedUpdateTiersSlider = debounce(() => updateTiersSlider(), 300);

window.addEventListener('resize', debouncedUpdateTiersSlider);

window.addEventListener('load', () => {
  setTimeout(() => {
    updateTiersSlider();
  }, 1000);
});